import { useState, useEffect } from "react";
import { useStore } from "../store/Store";
import Footer from "../components/Footer";

export default function AccountPage({ onNav }) {
  const { user, admin, signUp, signIn, signOut, orders, saveAddress, deleteAddress, notify } = useStore();
  const [tab, setTab] = useState(user ? "profile" : "login");
  const [form, setForm] = useState({ name:"", email:"", phone:"", pass:"" });
  const [isReg, setIsReg] = useState(false);
  const [busy, setBusy] = useState(false);
  const [showAddrForm, setShowAddrForm] = useState(false);
  const [addrForm, setAddrForm] = useState({ label:"Home", name:"", phone:"", address:"", city:"", state:"Maharashtra", pincode:"" });

  // If the account that just signed in is an admin, hand off to the Admin Panel automatically
  useEffect(()=>{
    if (admin) onNav("admin");
  }, [admin]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAuth = async () => {
    if (!form.email || !form.pass) { notify("Email aur password required","err"); return; }
    setBusy(true);

    if (!isReg) {
      const ok = await signIn(form.email, form.pass);
      if (ok) setTab("profile");
    } else {
      if (!form.name) { notify("Apna naam likho","err"); setBusy(false); return; }
      if (!form.phone || form.phone.length < 10) { notify("Valid 10-digit mobile number likho","err"); setBusy(false); return; }
      const ok = await signUp(form.name, form.email, form.phone, form.pass);
      if (ok) setTab("profile");
    }
    setBusy(false);
  };

  const tabs = [
    { id:"profile", emoji:"👤", label:"Profile" },
    { id:"addresses", emoji:"📍", label:"Addresses (" + (user?.addresses?.length||0) + ")" },
    { id:"orders",  emoji:"📦", label:"Orders (" + orders.length + ")" },
  ];

  if (!user) {
    return (
      <div className="page-top-pad" style={{ background:"#fafafa", minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:"80px 20px" }}>
        <div style={{ background:"white", borderRadius:24, padding:"clamp(28px,5vw,48px)", maxWidth:420, width:"100%", boxShadow:"0 8px 48px rgba(0,0,0,0.08)" }}>
          <div style={{ textAlign:"center", marginBottom:28 }}>
            <div style={{ fontFamily:"'Playfair Display',serif", fontSize:26, fontWeight:900, color:"#1a1a2e" }}>{isReg ? "Create Account" : "Welcome Back"}</div>
            <div style={{ fontSize:13, color:"#999", marginTop:4 }}>{isReg ? "Join for exclusive offers" : "Sign in to your account"}</div>
          </div>

          {isReg && (
            <>
              <label style={{ fontSize:9, letterSpacing:1, textTransform:"uppercase", color:"#999", display:"block", marginBottom:5, fontWeight:700 }}>Full Name *</label>
              <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Aapka naam" style={{ width:"100%", padding:"11px 16px", border:"1px solid #e5e5e5", borderRadius:12, fontSize:13, outline:"none", marginBottom:14 }}/>
              <label style={{ fontSize:9, letterSpacing:1, textTransform:"uppercase", color:"#999", display:"block", marginBottom:5, fontWeight:700 }}>Mobile Number *</label>
              <input type="tel" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="10-digit mobile number" style={{ width:"100%", padding:"11px 16px", border:"1px solid #e5e5e5", borderRadius:12, fontSize:13, outline:"none", marginBottom:14 }}/>
            </>
          )}

          <label style={{ fontSize:9, letterSpacing:1, textTransform:"uppercase", color:"#999", display:"block", marginBottom:5, fontWeight:700 }}>Email *</label>
          <input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="your@email.com" style={{ width:"100%", padding:"11px 16px", border:"1px solid #e5e5e5", borderRadius:12, fontSize:13, outline:"none", marginBottom:14 }}/>

          <label style={{ fontSize:9, letterSpacing:1, textTransform:"uppercase", color:"#999", display:"block", marginBottom:5, fontWeight:700 }}>Password *</label>
          <input type="password" value={form.pass} onChange={e=>setForm({...form,pass:e.target.value})} placeholder="••••••••" style={{ width:"100%", padding:"11px 16px", border:"1px solid #e5e5e5", borderRadius:12, fontSize:13, outline:"none", marginBottom:20 }} onKeyDown={e=>e.key==="Enter"&&handleAuth()}/>

          <button onClick={handleAuth} disabled={busy} style={{ width:"100%", padding:"14px", background:"#EC4899", color:"white", border:"none", borderRadius:50, fontSize:14, fontWeight:800, cursor:busy?"not-allowed":"pointer", opacity:busy?0.6:1, marginBottom:16 }}>
            {busy ? "Please wait…" : (isReg ? "Create Account" : "Sign In")}
          </button>

          <div style={{ textAlign:"center", fontSize:13, color:"#999" }}>
            {isReg ? "Already have account? " : "New here? "}
            <span onClick={()=>{setIsReg(!isReg); setForm({name:"",email:"",phone:"",pass:""}); }} style={{ color:"#EC4899", cursor:"pointer", fontWeight:700 }}>
              {isReg ? "Sign In" : "Register Free"}
            </span>
          </div>

          <div style={{ textAlign:"center", marginTop:20 }}>
            <span onClick={()=>onNav("checkout")} style={{ fontSize:12, color:"#999", cursor:"pointer", textDecoration:"underline" }}>
              Continue as guest →
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-top-pad" style={{ background:"#fafafa", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"24px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(20px,4vw,32px)", fontWeight:900, color:"white" }}>Hello, {user.name}! 👋</h1>
      </div>

      <div style={{ background:"white", borderBottom:"1px solid #f0f0f0", display:"flex", padding:"0 clamp(16px,4vw,40px)", overflowX:"auto" }}>
        {tabs.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)}
            style={{ padding:"14px 20px", border:"none", borderBottom:"3px solid " + (tab===t.id?"#EC4899":"transparent"), background:"none", color:tab===t.id?"#EC4899":"#999", fontWeight:tab===t.id?700:400, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", whiteSpace:"nowrap" }}>
            {t.emoji} {t.label}
          </button>
        ))}
        <button onClick={()=>signOut()}
          style={{ marginLeft:"auto", padding:"14px 20px", border:"none", background:"none", color:"#EF4444", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>
          Sign Out
        </button>
      </div>

      <div style={{ padding:"24px clamp(16px,4vw,40px)", maxWidth:700 }}>
        {tab==="profile" && (
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:28 }}>
              <div style={{ width:64, height:64, background:"linear-gradient(135deg,#EC4899,#7C3AED)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:26, color:"white", fontWeight:800 }}>
                {user.name[0].toUpperCase()}
              </div>
              <div>
                <div style={{ fontFamily:"'Playfair Display',serif", fontSize:20, fontWeight:900, color:"#1a1a2e" }}>{user.name}</div>
                <div style={{ fontSize:13, color:"#999" }}>{user.email}</div>
              </div>
            </div>
            <div style={{ background:"white", borderRadius:16, padding:20, boxShadow:"0 2px 12px rgba(0,0,0,0.05)" }}>
              {[["Name",user.name],["Email",user.email],["Phone",user.phone||"Not added"]].map(([k,v])=>(
                <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"12px 0", borderBottom:"1px solid #f5f5f5", fontSize:14 }}>
                  <span style={{ color:"#999", fontWeight:600 }}>{k}</span>
                  <span style={{ fontWeight:700, color:"#1a1a2e" }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab==="addresses" && (
          <div>
            {(user?.addresses||[]).map(a=>(
              <div key={a.id} style={{ background:"white", borderRadius:14, padding:16, marginBottom:10, boxShadow:"0 2px 12px rgba(0,0,0,0.05)", display:"flex", justifyContent:"space-between", gap:12, flexWrap:"wrap" }}>
                <div>
                  <span style={{ fontSize:10, fontWeight:800, background:"#FDF2F8", color:"#EC4899", padding:"2px 10px", borderRadius:20, textTransform:"uppercase", letterSpacing:1 }}>{a.label||"Address"}</span>
                  <div style={{ fontWeight:700, fontSize:14, marginTop:6 }}>{a.name} · {a.phone}</div>
                  <div style={{ fontSize:12, color:"#999" }}>{a.address}, {a.city}, {a.state} - {a.pincode}</div>
                </div>
                <button onClick={()=>deleteAddress(a.id)} style={{ background:"#FEF2F2", color:"#EF4444", border:"none", padding:"7px 14px", borderRadius:20, fontSize:11, fontWeight:700, cursor:"pointer", alignSelf:"flex-start" }}>Remove</button>
              </div>
            ))}
            {(!user?.addresses || user.addresses.length===0) && <p style={{ color:"#999", fontSize:13, marginBottom:16 }}>Koi saved address nahi hai abhi.</p>}

            {showAddrForm ? (
              <div style={{ background:"white", borderRadius:16, padding:20, boxShadow:"0 2px 12px rgba(0,0,0,0.05)", marginTop:10 }}>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
                  {[["label","Label (Home/Office)"],["name","Full Name"],["phone","Phone"],["address","Street Address"],["pincode","Pincode"],["city","City"],["state","State"]].map(([k,pl])=>(
                    <div key={k} style={{ gridColumn: k==="address"?"1/-1":"auto" }}>
                      <label style={{ fontSize:9, letterSpacing:1, textTransform:"uppercase", color:"#999", display:"block", marginBottom:4, fontWeight:700 }}>{pl}</label>
                      <input value={addrForm[k]} onChange={e=>setAddrForm({...addrForm,[k]:e.target.value})} style={{ width:"100%", padding:"9px 12px", border:"1px solid #e5e5e5", borderRadius:10, fontSize:13, outline:"none" }}/>
                    </div>
                  ))}
                </div>
                <div style={{ display:"flex", gap:10 }}>
                  <button onClick={async ()=>{
                    if (!addrForm.name||!addrForm.phone||!addrForm.address||!addrForm.city||!addrForm.pincode) { notify("Sab fields bharo","err"); return; }
                    const ok = await saveAddress(addrForm);
                    if (ok) { setShowAddrForm(false); setAddrForm({ label:"Home", name:"", phone:"", address:"", city:"", state:"Maharashtra", pincode:"" }); }
                  }} style={{ background:"#EC4899", color:"white", border:"none", padding:"10px 24px", borderRadius:50, fontSize:13, fontWeight:700, cursor:"pointer" }}>Save Address</button>
                  <button onClick={()=>setShowAddrForm(false)} style={{ background:"white", color:"#666", border:"1px solid #e5e5e5", padding:"10px 20px", borderRadius:50, fontSize:12, cursor:"pointer" }}>Cancel</button>
                </div>
              </div>
            ) : (
              <button onClick={()=>setShowAddrForm(true)} style={{ background:"white", border:"2px dashed #EC4899", borderRadius:12, padding:"12px 24px", fontSize:13, fontWeight:700, color:"#EC4899", cursor:"pointer" }}>+ Add New Address</button>
            )}
          </div>
        )}

        {tab==="orders" && (
          <div>
            {orders.length===0 ? (
              <div style={{ textAlign:"center", padding:"60px 0" }}>
                <div style={{ fontSize:48, marginBottom:12 }}>📦</div>
                <p style={{ color:"#999", marginBottom:16 }}>No orders yet.</p>
                <button onClick={()=>onNav("shop")} style={{ background:"#EC4899", color:"white", border:"none", padding:"12px 28px", borderRadius:50, fontSize:13, fontWeight:700, cursor:"pointer" }}>Shop Now</button>
              </div>
            ) : orders.map(o=>(
              <div key={o.id} style={{ background:"white", borderRadius:16, padding:18, marginBottom:12, boxShadow:"0 2px 12px rgba(0,0,0,0.05)" }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10, flexWrap:"wrap", gap:8 }}>
                  <div>
                    <div style={{ fontWeight:800, color:"#1a1a2e", fontSize:14 }}>{o.id}</div>
                    <div style={{ fontSize:11, color:"#999" }}>{o.date} · {o.items?.length} items</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ fontWeight:900, fontSize:16, color:"#1a1a2e" }}>₹{o.total?.toLocaleString("en-IN")}</div>
                    <span style={{ fontSize:10, fontWeight:700, background:"#F0FDF4", color:"#16A34A", padding:"2px 10px", borderRadius:20 }}>{o.status}</span>
                  </div>
                </div>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  <a href={"https://wa.me/918766584266?text=" + encodeURIComponent("Track order " + o.id)} target="_blank" rel="noreferrer"
                    style={{ fontSize:11, fontWeight:700, color:"#16A34A", background:"#F0FDF4", border:"1px solid #86EFAC", padding:"6px 14px", borderRadius:50, textDecoration:"none" }}>💬 Track</a>
                  <a href={"https://wa.me/918766584266?text=" + encodeURIComponent("Return order " + o.id + " - Reason: ")} target="_blank" rel="noreferrer"
                    style={{ fontSize:11, fontWeight:700, color:"#EF4444", background:"#FEF2F2", border:"1px solid #FECACA", padding:"6px 14px", borderRadius:50, textDecoration:"none" }}>↩️ Return</a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
